import clientServerBridge from '@atlassian/help-center-common-util/client-server-bridge/client-server-bridge';
type ProvidedI18nMessages = Record<string, string>;

export default function (): ProvidedI18nMessages {
    const windowRef = clientServerBridge.getWindow();
    windowRef.__JSD_I18N_MESSAGES = windowRef.__JSD_I18N_MESSAGES || {};
    return windowRef.__JSD_I18N_MESSAGES;
}
